import axiosClient from "./axiosClient";
import { IListProductsParams } from "./categories";

export const instrumentApi = {
    getInstrument: (params: IListProductsParams) => {
        const url = `/api/search-instrument?categoryId=${params.category}&name=${params.name}`;
        return axiosClient.get(url);
    },
    getInstrumentList: (params: {id:number, category:number}) => {
        const url = `/api/instrument-item/${params.id}/?category=${params.category}`;
        return axiosClient.get(url);
    },
    getInstrumentDetail: (params: {id:number} ) => {
        const url = `api/instrumentItem-detail/${params.id}`;
        return axiosClient.get(url);
    },
    getInstrumentCalendar: (params:any)=>{
        const url = `/api/instrumentItem-history/${params.id}?onlyActive=${params.onlyActive}`;
        return axiosClient.get(url);
    },
    borrowInstrument: (params: any,id:any)=>{
        const url = `/api/borrowing-instrumentItem/${id}`;
        return axiosClient.post(url,params);
    },
    instrumentRecurring: (params:any,id:any) =>{
        const url = `/api/instrumentItem-recurring/${id}`;
        return axiosClient.post(url,params);
    },
    instrumentModify: (params:any,id:any) =>{
        const url = `/api/instrumentItem-modification/${id}`;
        return axiosClient.post(url,params);
    },
    updateBorrowItem: (params:any,id: any)=>{
        const url = `/api/update-borrowing/${id}`;
        return axiosClient.put(url,params);
    },
    getInstrumentBorrowingHistory: (params: any) => {
        const url = `/api/instrumentItem-history/${params.id}/${params.itemId}`;
        return axiosClient.get(url);
    },
    getInstrumentBorrowingList: (params: {
      year: number,
      month: number,
      category_id?: number;
      subCategory_id?:number;
      searchWord?: string;
    }) => {
        // const url = `/api/instrument-borrowing?year=${params.year}&month=${params.month}`;
        const searchParams = new URLSearchParams({
          year: params.year.toString(),
          month: params.month.toString(),
      });

      if (params.category_id !== undefined) {
          searchParams.append('category_id', params.category_id.toString());
      }

      if (params.subCategory_id !== undefined) {
          searchParams.append('subCategory_id', params.subCategory_id.toString());
      }

      if (params.searchWord !== undefined) {
          searchParams.append('searchWord', params.searchWord.toString());
      }

      const url = `/api/instrument-borrowing?onlyActive=false&${searchParams.toString()}`;

      return axiosClient.get(url);
    }
};
